/**
 * De pictogrammen van ikzoekbaas.nl: het hartje bij stap 1, het spaarvarken bij de tarieven, de
 * telefoonhoorn bij het contact, en de chevron van de uitklapper. Overgenomen van die site zelf
 * (augustus 2026) zodat de preview er niet "bijna" uitziet maar precies.
 *
 * <p>Ze staan hier apart omdat het pure vorm is: lange pad-data die niets zegt over hoe het scherm werkt,
 * en die de preview-component anders onleesbaar zou maken.
 */
import logoMarkup from "../assets/ikzoekbaas/dierenbescherming-logo.svg?raw";

const HART =
  "M6.8 3.8C4.7 3.8 3 5.4 3 7.5c0 2.3 1.3 4.7 3.4 7.1 1.7 2 3.8 3.8 5.6 5.3 1.8-1.5 3.9-3.3 5.6-5.3 2-2.4 3.4-4.8 3.4-7.1 0-2-1.7-3.7-3.8-3.7s-3.8 1.7-3.8 3.7c0 .4-.2.8-.4 1.1-.2.2-.6.4-1 .4s-.8-.2-1.1-.4c-.3-.3-.4-.7-.4-1.1 0-2.1-1.7-3.7-3.7-3.7zm5.2-.6c-.6-.8-1.4-1.4-2.3-1.8C8.7 1 7.8.7 6.8.8 3 .8 0 3.7 0 7.5c0 3.4 1.9 6.5 4.1 9.1 2.2 2.6 4.9 4.8 7 6.4.3.2.6.3.9.3.3 0 .7-.1.9-.3 2-1.6 4.8-3.8 7-6.4C22.1 14 24 10.8 24 7.5c0-3.7-3-6.7-6.8-6.7-2.1 0-4 .9-5.2 2.4z";

const SPAARVARKEN =
  "M12.8 5.4c4.1-.1 7.7 3 8.2 7.1h.5c.1 0 .2 0 .3-.1l.2-.2v-.3c0-.1-.1-.2-.1-.3l-.1-.1c-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7s.4-.3.7-.3c.3 0 .5.1.7.3l.1.1c1.6 1.6.5 4.3-1.7 4.3H21c-.2 1.4-1 2.5-1.9 3.4v3.6c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3h-3c-.2 0-.4-.1-.6-.2-.2-.1-.3-.3-.4-.5l-.4-1.1c-.1-.4-.3-.7-.6-.9-.3-.2-.7-.3-1-.3-.4 0-.7.1-1 .3-.3.2-.5.5-.6.9l-.5 1.1c-.1.2-.2.4-.4.5-.2.1-.4.2-.6.2H6c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7v-3c0-.5-.4-1.2-1.3-1.9-.8-.6-1.9-1.1-2.8-1.1-.2 0-.5-.1-.6-.3-.2-.2-.3-.5-.3-.7v-4c0-.2.1-.4.1-.5.1-.2.2-.3.4-.4l1.6-.8C2.8 7 4.5 5.9 6 5.6V2.5c0-.2.1-.5.2-.6.1-.2.4-.3.6-.3H8c2 .2 4.1 1.9 4.8 3.8zM8 6.5V3.6c1.2.3 2.9 1.5 3 2.9 0 .1 0 .3.1.4.1.1.1.2.2.3.1.1.2.2.4.2.1 0 .3.1.4 0h.3c3.5-.4 6.6 2.5 6.6 6 0 1-.4 2-1.1 2.7l-.2.2c-.3.4-.7.7-.7 1.2v3h-1.3l-.1-.4c-.3-.8-.7-1.4-1.4-1.9-.6-.5-1.4-.7-2.2-.7-.8 0-1.6.2-2.2.7-.6.5-1.1 1.1-1.4 1.9l-.1.4H7v-2C7 17 6 15.8 4.9 15c-.9-.6-1.8-1.1-2.9-1.3v-2.5l1.4-.7.3-.3c.2-.2.2-.3.3-.5.4-1.4 1.9-2.2 3-2.2.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7zm-.5 6c.4 0 .8-.2 1.1-.4.2-.3.4-.7.4-1.1 0-.4-.2-.8-.4-1.1-.3-.3-.7-.4-1.1-.4-.4 0-.8.2-1.1.4-.2.3-.4.7-.4 1.1 0 .4.2.8.4 1.1.3.2.7.4 1.1.4z";

const TELEFOON =
  "M8.2 15.8c2.9 2.9 5.6 4.5 7.5 5.4 1.7.8 3.8.2 5.4-1.4l.4-.4-4.4-2.8c-.8 1.2-2.4 1.9-4 1.3-1.2-.5-2.8-1.4-4.2-2.8-1.4-1.4-2.3-3-2.8-4.2-.7-1.6 0-3.2 1.3-4L4.6 2.5l-.3.4C2.7 4.5 2.1 6.5 2.8 8.2c.9 2 2.5 4.7 5.4 7.6zm6.5 7.6c-2.3-1-5.2-2.8-8.3-5.9-3.1-3.1-4.9-6-5.9-8.3C-.8 6.2.4 3.1 2.4 1l.4-.4c.3-.3.6-.5.9-.6h1.2c.4 0 .7.2 1 .4.3.2.6.5.8.8l3.5 5.5c.1.1.2.3.2.5v.5c0 .2-.1.3-.2.5-.2.1-.3.2-.5.3l-.7.4c-.6.2-.7.7-.6 1 .4 1 1.1 2.3 2.2 3.4s2.4 1.8 3.4 2.2c.3.1.8 0 1.1-.5l.4-.8c.1-.2.2-.3.3-.4.1-.1.3-.2.5-.2s.3-.1.5 0c.2 0 .3.1.5.2l5.5 3.5c.3.2.6.5.8.8.2.3.3.7.4 1 0 .4 0 .7-.1 1.1-.1.4-.3.7-.6.9l-.4.4c-2.1 2.1-5.2 3.3-8.2 1.9z";

const CHEVRON =
  "M.4 5.7c.3-.3.7-.4 1.1-.4.4 0 .8.2 1.1.4l9.4 9.4 9.4-9.4c.1-.1.3-.3.5-.3s.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.4.2.5.3.1.1.3.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.3.5L13.1 18.3c-.3.3-.7.4-1.1.4-.4 0-.8-.2-1.1-.4L.4 7.8c-.2-.3-.4-.6-.4-1s.2-.8.4-1.1z";

const PADEN: Record<number, string> = { 1: HART, 2: SPAARVARKEN, 3: TELEFOON };

/** Het pictogram voor stap 1, 2 of 3. */
export function StapIcoon({ nr }: { nr: number }) {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__stap-icoon">
      {/* Het spaarvarken is een omlijning: zonder evenodd loopt de binnenkant vol en zie je een vlek. */}
      <path fill="currentColor" fillRule={nr === 2 ? "evenodd" : undefined} d={PADEN[nr] ?? HART} />
    </svg>
  );
}

/** De chevron van de uitklapper; open draait hem een halve slag, net als daar. */
export function StapChevron({ open }: { open: boolean }) {
  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      className={open ? "izb__chevron is-open" : "izb__chevron"}
    >
      <path fill="currentColor" d={CHEVRON} />
    </svg>
  );
}

/**
 * Het logo van de Dierenbescherming zoals het op ikzoekbaas.nl staat, als bestand in de repo
 * (src/assets/ikzoekbaas). Met {@code kort} blijft alleen het limoenvlak met de poot over — zo staat
 * het daar op een telefoon, zonder de merknaam ernaast.
 */
export function MerkLogo({ kort = false }: { kort?: boolean }) {
  return (
    <span
      className={kort ? "izb__logo izb__logo--kort" : "izb__logo"}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: logoMarkup }}
    />
  );
}

/** De envelop in de contactknop; die staat daar links van de tekst. */
export function KnopEnvelop() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__knop-pijl">
      <path
        fill="currentColor"
        d="M2 4h20c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1zm1 3.2V18h18V7.2l-8.4 6c-.4.3-.8.3-1.2 0L3 7.2zM20 6H4l8 5.7L20 6z"
      />
    </svg>
  );
}

/**
 * De knoppenrij onder een Instagram-bericht: hart, reactie, delen en bewaren. Lijntekeningen, want
 * emoji zien er per systeem anders uit en dan lijkt het geen app maar een rij plaatjes.
 */
export function IgIcoon({ soort }: { soort: "hart" | "reactie" | "delen" | "bewaar" }) {
  const paden = {
    hart: "M12 21s-7.5-4.7-9.6-9C1 9.2 2.3 5.6 5.6 4.7 7.7 4.1 9.9 4.9 12 7.2c2.1-2.3 4.3-3.1 6.4-2.5 3.3.9 4.6 4.5 3.2 7.3-2.1 4.3-9.6 9-9.6 9z",
    reactie: "M12 3c5 0 9 3.4 9 7.6 0 4.2-4 7.6-9 7.6-.9 0-1.8-.1-2.6-.3L4 21l1.4-3.6C3.9 16 3 13.4 3 10.6 3 6.4 7 3 12 3z",
    delen: "M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z",
    bewaar: "M6 3h12v18l-6-4.5L6 21V3z",
  } as const;
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__ig-icoon">
      <path d={paden[soort]} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}

/** Het pijltje in de limoenknoppen. */
export function KnopPijl() {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-hidden="true" className="izb__knop-pijl">
      <path
        fill="currentColor"
        d="M13.3 4.3c.4-.4 1-.4 1.4 0l6.5 6.5c.4.4.4 1 0 1.4l-6.5 6.5c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l4.8-4.8H3c-.6 0-1-.4-1-1s.4-1 1-1h15.1l-4.8-4.8c-.4-.4-.4-1 0-1.4z"
      />
    </svg>
  );
}
